var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1200",
    height: 1200,
    width: 1600,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1200)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#d3e5f1",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11195.4,4079.3 c -66.4,874.67 -562.4,1646.98 -1113.1,2300.82 -260.76,309.63 -535.51,610.55 -820.24,898.32 -317.43,320.84 -650.08,613.66 -1051.15,825.84 -400.41,211.83 -870.39,293.95 -1317.24,210.17 -489.18,-91.72 -918.75,-334.96 -1336.56,-593.9 C 4717.32,7200.08 3884.99,6667.19 3049.18,6140.37 2681.9,5908.87 2304.96,5687.13 1955.81,5428.44 1776.09,5295.29 1611.02,5148.64 1455.63,4987.86 1300.79,4827.66 1176.53,4652.2 1067.76,4458.04 831.477,4036.26 769.336,3537.63 805.281,3061.51 841.438,2582.6 997.996,2114.9 1186.53,1676.1 c 53.91,-125.44 400.26,-779.631 487.78,-815.569 67.95,-27.922 8077.62,-202.14 8280.28,-95.25 220.01,116.051 406.91,282.269 537.31,495.279 116.5,190.17 201.7,390.27 274.2,600.51 75.8,219.71 149.9,440.31 215.5,663.27 149.6,508.04 254.3,1022.65 213.8,1554.96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#4b8ab7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 11128.5,838.629 c 0,-245.988 -2309.11,-445.418 -5157.51,-445.418 -2848.42,0 -5157.513,199.43 -5157.513,445.418 0,246.001 2309.093,445.411 5157.513,445.411 2848.4,0 5157.51,-199.41 5157.51,-445.411"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#b7d2e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9180.03,1707.53 H 8905 c -30.92,0 -56.21,25.29 -56.21,56.21 v 275.03 c 0,30.92 25.29,56.21 56.21,56.21 h 275.03 c 30.92,0 56.21,-25.29 56.21,-56.21 v -275.03 c 0,-30.92 -25.29,-56.21 -56.21,-56.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#9abfdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8938.21,1901.25 c 0,57.61 46.7,104.3 104.3,104.3 57.61,0 104.3,-46.69 104.3,-104.3 0,-57.6 -46.69,-104.3 -104.3,-104.3 -57.6,0 -104.3,46.7 -104.3,104.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#b7d2e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8985.23,1901.25 c 0,6.87 5.56,12.43 12.43,12.43 6.85,0 12.42,-5.56 12.42,-12.43 0,-6.86 -5.57,-12.42 -12.42,-12.42 -6.87,0 -12.43,5.56 -12.43,12.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#b7d2e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9074.95,1901.25 c 0,6.87 5.56,12.43 12.42,12.43 6.86,0 12.42,-5.56 12.42,-12.43 0,-6.86 -5.56,-12.42 -12.42,-12.42 -6.86,0 -12.42,5.56 -12.42,12.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#b7d2e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8680.31,1707.53 h -275.02 c -30.91,0 -56.22,25.29 -56.22,56.21 v 275.03 c 0,30.92 25.31,56.21 56.22,56.21 h 275.02 c 30.92,0 56.21,-25.29 56.21,-56.21 v -275.03 c 0,-30.92 -25.29,-56.21 -56.21,-56.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#5a95bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8438.51,1901.25 c 0,57.61 46.69,104.3 104.29,104.3 57.6,0 104.3,-46.69 104.3,-104.3 0,-57.6 -46.7,-104.3 -104.3,-104.3 -57.6,0 -104.29,46.7 -104.29,104.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#5a95bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8500.78,1889.19 c 5.49,1.28 9.58,6.18 9.58,12.06 0,6.87 -5.56,12.43 -12.42,12.43 -3.85,0 -7.26,-1.8 -9.53,-4.55 -0.18,0.25 -0.34,0.52 -0.52,0.78 -10.23,14.91 -32.27,-2.55 -22.06,-17.43 102.7,-149.57 10.43,-368.1 -147.69,-435.34 -190.79,-81.14 -418.09,19.66 -527.92,184.64 -30.57,45.93 -52.78,98.24 -61.79,152.79 -9.85,59.6 0.02,119.02 1.59,178.81 1.45,55.03 -6.18,106.9 -34.07,155.06 -26.54,45.8 -63.2,85.24 -83.57,134.58 -43.17,104.55 -18.11,222.82 -0.69,330.17 17.5,107.83 24.88,216.07 17.69,325.21 -15.99,242.9 -97.82,479.92 -235.26,680.78 -10.21,14.92 -32.25,-2.54 -22.06,-17.43 132.49,-193.61 211.21,-421.68 228.66,-655.53 8.79,-117.73 -1.17,-233.24 -20.18,-349.44 -18.2,-111.19 -38.35,-233.38 12.45,-339.31 23.93,-49.9 63.71,-90.09 87.7,-139.85 28.69,-59.53 21.6,-125.16 17.36,-188.94 -3.75,-56.39 -2.54,-111 13.63,-165.56 15.39,-51.9 41.36,-100.51 74.1,-143.52 120.32,-158.01 346.16,-247.9 537.13,-170.92 172.11,69.39 271.27,294.9 177.87,460.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#5a95bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8575.23,1901.25 c 0,6.87 5.57,12.43 12.43,12.43 6.86,0 12.43,-5.56 12.43,-12.43 0,-6.86 -5.57,-12.42 -12.43,-12.42 -6.86,0 -12.43,5.56 -12.43,12.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2058.37,1365.98 v 0 c -28.75,0 -52.27,23.52 -52.27,52.27 v 729.29 c 0,28.75 23.52,52.27 52.27,52.27 v 0 c 28.75,0 52.26,-23.52 52.26,-52.27 v -729.29 c 0,-28.75 -23.51,-52.27 -52.26,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2035.97,1365.98 v 0 c -28.75,0 -52.27,23.52 -52.27,52.27 v 729.29 c 0,28.75 23.52,52.27 52.27,52.27 v 0 c 28.75,0 52.26,-23.52 52.26,-52.27 v -729.29 c 0,-28.75 -23.51,-52.27 -52.26,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2234.59,1365.98 h -0.01 c -28.74,0 -52.27,23.52 -52.27,52.27 v 729.29 c 0,28.75 23.53,52.27 52.27,52.27 h 0.01 c 28.74,0 52.27,-23.52 52.27,-52.27 v -729.29 c 0,-28.75 -23.53,-52.27 -52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2212.19,1365.98 v 0 c -28.75,0 -52.28,23.52 -52.28,52.27 v 729.29 c 0,28.75 23.53,52.27 52.28,52.27 v 0 c 28.74,0 52.26,-23.52 52.26,-52.27 v -729.29 c 0,-28.75 -23.52,-52.27 -52.26,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2410.8,1365.98 v 0 c -28.75,0 -52.26,23.52 -52.26,52.27 v 729.29 c 0,28.75 23.51,52.27 52.26,52.27 v 0 c 28.75,0 52.28,-23.52 52.28,-52.27 v -729.29 c 0,-28.75 -23.53,-52.27 -52.28,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2388.4,1365.98 v 0 c -28.74,0 -52.27,23.52 -52.27,52.27 v 729.29 c 0,28.75 23.53,52.27 52.27,52.27 v 0 c 28.75,0 52.27,-23.52 52.27,-52.27 v -729.29 c 0,-28.75 -23.52,-52.27 -52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2587.02,1365.98 v 0 c -28.75,0 -52.26,23.52 -52.26,52.27 v 729.29 c 0,28.75 23.51,52.27 52.26,52.27 v 0 c 28.75,0 52.27,-23.52 52.27,-52.27 v -729.29 c 0,-28.75 -23.52,-52.27 -52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2564.62,1365.98 v 0 c -28.75,0 -52.27,23.52 -52.27,52.27 v 729.29 c 0,28.75 23.52,52.27 52.27,52.27 v 0 c 28.75,0 52.26,-23.52 52.26,-52.27 v -729.29 c 0,-28.75 -23.51,-52.27 -52.26,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3106.72,1365.98 v 0 c 28.74,0 52.26,23.52 52.26,52.27 v 729.29 c 0,28.75 -23.52,52.27 -52.26,52.27 v 0 c -28.75,0 -52.28,-23.52 -52.28,-52.27 v -729.29 c 0,-28.75 23.53,-52.27 52.28,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3129.11,1365.98 v 0 c 28.75,0 52.28,23.52 52.28,52.27 v 729.29 c 0,28.75 -23.53,52.27 -52.28,52.27 v 0 c -28.74,0 -52.26,-23.52 -52.26,-52.27 v -729.29 c 0,-28.75 23.52,-52.27 52.26,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2930.5,1365.98 v 0 c 28.75,0 52.26,23.52 52.26,52.27 v 729.29 c 0,28.75 -23.51,52.27 -52.26,52.27 v 0 c -28.75,0 -52.27,-23.52 -52.27,-52.27 v -729.29 c 0,-28.75 23.52,-52.27 52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2952.9,1365.98 v 0 c 28.74,0 52.27,23.52 52.27,52.27 v 729.29 c 0,28.75 -23.53,52.27 -52.27,52.27 v 0 c -28.75,0 -52.27,-23.52 -52.27,-52.27 v -729.29 c 0,-28.75 23.52,-52.27 52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2740.84,1365.98 v 0 c 28.75,0 52.27,23.52 52.27,52.27 v 729.29 c 0,28.75 -23.52,52.27 -52.27,52.27 v 0 c -28.75,0 -52.27,-23.52 -52.27,-52.27 v -729.29 c 0,-28.75 23.52,-52.27 52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2763.24,1365.98 v 0 c 28.74,0 52.27,23.52 52.27,52.27 v 729.29 c 0,28.75 -23.53,52.27 -52.27,52.27 v 0 c -28.75,0 -52.27,-23.52 -52.27,-52.27 v -729.29 c 0,-28.75 23.52,-52.27 52.27,-52.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3182.08,1125.5 H 1984.89 v 339.71 H 3182.08 V 1125.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3182.08,2090.07 H 1984.89 v 334.3 h 1197.19 v -334.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3182.08,1122.86 c 0,-54.33 -268,-98.38 -598.59,-98.38 -330.59,0 -598.6,44.05 -598.6,98.38 0,54.33 268.01,98.37 598.6,98.37 330.59,0 598.59,-44.04 598.59,-98.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3182.08,2420.7 c 0,-54.33 -268,-98.38 -598.59,-98.38 -330.59,0 -598.6,44.05 -598.6,98.38 0,54.33 268.01,98.37 598.6,98.37 330.59,0 598.59,-44.04 598.59,-98.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3147.13,2429.78 c 0,-35.34 -252.35,-63.98 -563.64,-63.98 -311.29,0 -563.64,28.64 -563.64,63.98 0,35.33 252.35,63.97 563.64,63.97 311.29,0 563.64,-28.64 563.64,-63.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3054.44,1465.21 h -49.27 v 624.86 h 49.27 z m -176.21,0 h -62.72 v 624.86 h 62.72 z m 303.85,624.86 v 334.3 h -0.46 c -9.25,41.5 -174.98,76.44 -403.13,89.35 -0.33,-111.23 -2.46,-222.46 -6.76,-333.61 -14.95,-386.96 -54.64,-773.08 -119.02,-1154.96 297.98,5.63 529.37,47.22 529.37,97.71 0,0.88 -0.08,1.76 -0.21,2.64 h 0.21 v 339.71 h -0.69 v 624.86 h 0.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8542.8,3344 -0.05,-0.38 -15.55,-154.58 -7.96,-79.03 -9.04,-89.56 -202.79,-2012.25 c -1.92,-19.11 -18.03,-33.68 -37.29,-33.68 h -63.38 c -21.17,0 -38.14,17.468 -37.47,38.64 l 63.51,2007.29 2.82,89.56 2.48,79.03 4.92,154.58 v 0.38 h 299.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9777.06,1013.16 c 0.69,-21.172 -16.26,-38.64 -37.43,-38.64 h -63.43 c -19.26,0 -35.37,14.57 -37.28,33.68 l -202.75,2012.25 -9.04,89.56 -7.96,79.03 -15.56,154.58 -0.05,0.38 h 299.81 v -0.38 l 4.92,-154.58 2.48,-79.03 2.81,-89.56 63.48,-2007.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8243,3343.62 h 299.75 l -15.55,-154.58 -7.96,-79.03 H 8235.6 l 2.48,79.03 4.92,154.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9710.77,3110.01 h -283.64 l -7.96,79.03 -15.56,154.58 h 299.76 l 4.92,-154.58 2.48,-79.03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2688.63,974.5 h -63.41 c -21.16,0 -38.12,17.512 -37.46,38.66 l 73.73,2330.83 H 2961.3 L 2725.92,1008.22 c -1.94,-19.15 -18.05,-33.72 -37.29,-33.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4094.71,974.5 h 63.41 c 21.16,0 38.12,17.512 37.46,38.66 l -73.73,2330.83 h -299.81 l 235.38,-2335.77 c 1.93,-19.15 18.05,-33.72 37.29,-33.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#f2b263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2605.24,3329.55 h 7098.32 c 41.4,0 74.96,33.56 74.96,74.95 v 290.87 c 0,56.27 -46.04,102.31 -102.31,102.31 H 2632.6 c -56.27,0 -102.31,-46.04 -102.31,-102.31 V 3404.5 c 0,-41.22 33.73,-74.95 74.95,-74.95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#ffe989",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9927.49,3836.46 H 2381.32 c -47.91,0 -87.12,-39.5 -87.12,-87.78 v -176.37 c 0,-48.28 39.21,-87.78 87.12,-87.78 h 588.73 6368.71 588.73 c 47.91,0 87.11,39.5 87.11,87.78 v 176.37 c 0,48.28 -39.2,87.78 -87.11,87.78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#f2b263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9995.92,3836.46 H 8152.25 v -351.93 h 1843.67 c 40.58,0 73.58,28.49 73.58,63.63 v 224.67 c 0,35.15 -33,63.63 -73.58,63.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#9abfdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6949.85,3859.56 h -539.42 v 962.15 h 539.42 v -962.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#b7d2e5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8138.43,4316.97 H 5367.2 v 1744.17 h 2771.23 c 37.77,0 68.4,-30.62 68.4,-68.4 V 4385.37 c 0,-37.77 -30.63,-68.4 -68.4,-68.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 7261.21,3829.64 H 6099.07 c -37.77,0 -68.4,30.62 -68.4,68.4 v 25.64 c 0,37.78 30.63,68.4 68.4,68.4 h 1162.14 c 37.77,0 68.4,-30.62 68.4,-68.4 v -25.64 c 0,-37.78 -30.63,-68.4 -68.4,-68.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8031.55,4316.97 H 5328.73 c -37.78,0 -68.4,30.63 -68.4,68.4 v 1607.37 c 0,37.78 30.62,68.4 68.4,68.4 h 2702.82 c 37.79,0 68.4,-30.62 68.4,-68.4 V 4385.37 c 0,-37.77 -30.61,-68.4 -68.4,-68.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7949.24,4579.51 h -2538.2 c -32.67,0 -59.16,26.49 -59.16,59.17 v 1276.7 c 0,32.68 26.49,59.17 59.16,59.17 h 2538.2 c 32.67,0 59.16,-26.49 59.16,-59.17 v -1276.7 c 0,-32.68 -26.49,-59.17 -59.16,-59.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 6989.62,4682.41 H 5519.81 c -28.67,0 -52.13,23.47 -52.13,52.15 v 1077.79 c 0,28.68 23.46,52.14 52.13,52.14 h 1469.81 c 28.68,0 52.14,-23.46 52.14,-52.14 V 4734.56 c 0,-28.68 -23.46,-52.15 -52.14,-52.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7041.76,5812.34 v -29.07 H 5467.7 v 29.07 c 0,28.69 23.42,52.15 52.11,52.15 h 1469.8 c 28.68,0 52.15,-23.46 52.15,-52.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5514.91,5823.88 c 0,7.87 6.38,14.25 14.25,14.25 7.87,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.38,-14.25 -14.25,-14.25 -7.87,0 -14.25,6.38 -14.25,14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5566.29,5823.88 c 0,7.87 6.39,14.25 14.26,14.25 7.86,0 14.24,-6.38 14.24,-14.25 0,-7.87 -6.38,-14.25 -14.24,-14.25 -7.87,0 -14.26,6.38 -14.26,14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5617.68,5823.88 c 0,7.87 6.37,14.25 14.24,14.25 7.87,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.38,-14.25 -14.25,-14.25 -7.87,0 -14.24,6.38 -14.24,14.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5815.36,4769.83 h -277.89 c -19,0 -34.55,15.55 -34.55,34.55 v 910.96 c 0,19 15.55,34.55 34.55,34.55 h 277.89 c 19,0 34.54,-15.55 34.54,-34.55 v -910.96 c 0,-19 -15.54,-34.55 -34.54,-34.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5649.36 h -52.47 c -5.62,0 -10.21,4.6 -10.21,10.21 v 52.47 c 0,5.61 4.59,10.2 10.21,10.2 h 52.47 c 5.6,0 10.2,-4.59 10.2,-10.2 v -52.47 c 0,-5.61 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5545.3 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.21 v 52.46 c 0,5.61 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.6 10.2,-10.21 v -52.46 c 0,-5.62 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5441.24 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.21 v 52.46 c 0,5.62 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.59 10.2,-10.21 v -52.46 c 0,-5.62 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5337.18 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.2 v 52.47 c 0,5.61 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.6 10.2,-10.21 v -52.47 c 0,-5.61 -4.6,-10.2 -10.2,-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5233.12 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.21 v 52.46 c 0,5.62 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.59 10.2,-10.21 v -52.46 c 0,-5.62 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5129.06 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.2 v 52.47 c 0,5.61 4.59,10.2 10.21,10.2 h 52.47 c 5.6,0 10.2,-4.59 10.2,-10.2 v -52.47 c 0,-5.61 -4.6,-10.2 -10.2,-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,5025 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.2 v 52.47 c 0,5.61 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.6 10.2,-10.21 v -52.47 c 0,-5.61 -4.6,-10.2 -10.2,-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,4920.93 h -52.47 c -5.62,0 -10.21,4.6 -10.21,10.21 v 52.47 c 0,5.61 4.59,10.2 10.21,10.2 h 52.47 c 5.6,0 10.2,-4.59 10.2,-10.2 v -52.47 c 0,-5.61 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5592.53,4816.87 h -52.47 c -5.62,0 -10.21,4.59 -10.21,10.21 v 52.47 c 0,5.61 4.59,10.21 10.21,10.21 h 52.47 c 5.6,0 10.2,-4.6 10.2,-10.21 v -52.47 c 0,-5.62 -4.6,-10.21 -10.2,-10.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5696.07 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5653.91 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5592.01 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5713.16,5549.85 h -70.43 c -5.94,0 -10.81,4.87 -10.81,10.81 v 0 c 0,5.95 4.87,10.81 10.81,10.81 h 70.43 c 5.95,0 10.81,-4.86 10.81,-10.81 v 0 c 0,-5.94 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5487.95 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5445.79 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5676.16,5383.89 h -33.43 c -5.96,0 -10.81,4.84 -10.81,10.81 v 0 c 0,5.97 4.85,10.81 10.81,10.81 h 33.43 c 5.97,0 10.81,-4.84 10.81,-10.81 v 0 c 0,-5.97 -4.84,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5746.7,5383.89 h -33.43 c -5.97,0 -10.81,4.84 -10.81,10.81 v 0 c 0,5.97 4.84,10.81 10.81,10.81 h 33.43 c 5.97,0 10.81,-4.84 10.81,-10.81 v 0 c 0,-5.97 -4.84,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5341.73 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5676.16,4967.65 h -33.43 c -5.96,0 -10.81,4.84 -10.81,10.8 v 0 c 0,5.97 4.85,10.81 10.81,10.81 h 33.43 c 5.97,0 10.81,-4.84 10.81,-10.81 v 0 c 0,-5.96 -4.84,-10.8 -10.81,-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5746.7,4967.65 h -33.43 c -5.97,0 -10.81,4.84 -10.81,10.8 v 0 c 0,5.97 4.84,10.81 10.81,10.81 h 33.43 c 5.97,0 10.81,-4.84 10.81,-10.81 v 0 c 0,-5.96 -4.84,-10.8 -10.81,-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,4925.49 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.8 v 0 c 0,5.95 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.86 10.81,-10.81 v 0 c 0,-5.94 -4.86,-10.8 -10.81,-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5279.83 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.8 v 0 c 0,5.95 4.87,10.82 10.81,10.82 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.82 v 0 c 0,-5.94 -4.86,-10.8 -10.81,-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5237.67 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5175.77 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.8 10.81,10.8 H 5767 c 5.95,0 10.81,-4.86 10.81,-10.8 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5718.55,5133.61 h -75.82 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.8 10.81,10.8 h 75.82 c 5.95,0 10.82,-4.86 10.82,-10.8 v 0 c 0,-5.95 -4.87,-10.81 -10.82,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5071.7 h -124.27 c -5.94,0 -10.81,4.87 -10.81,10.81 v 0 c 0,5.95 4.87,10.82 10.81,10.82 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.82 v 0 c 0,-5.94 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,5029.55 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.87 10.81,-10.81 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,4863.58 h -124.27 c -5.94,0 -10.81,4.87 -10.81,10.81 v 0 c 0,5.95 4.87,10.81 10.81,10.81 H 5767 c 5.95,0 10.81,-4.86 10.81,-10.81 v 0 c 0,-5.94 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5767,4821.43 h -124.27 c -5.94,0 -10.81,4.86 -10.81,10.81 v 0 c 0,5.94 4.87,10.8 10.81,10.8 H 5767 c 5.95,0 10.81,-4.86 10.81,-10.8 v 0 c 0,-5.95 -4.86,-10.81 -10.81,-10.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5915.32,4863.58 v 0 c -5.88,0 -10.68,4.81 -10.68,10.69 v 864.93 c 0,5.88 4.8,10.69 10.68,10.69 v 0 c 5.88,0 10.7,-4.81 10.7,-10.69 v -864.93 c 0,-5.88 -4.82,-10.69 -10.7,-10.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6490.63,5356.2 h -184.39 c -6.72,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.73 5.51,12.22 12.23,12.22 h 184.39 c 6.71,0 12.22,-5.49 12.22,-12.22 v 0 c 0,-6.73 -5.51,-12.23 -12.22,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6111.24,5356.2 h -108.88 c -6.73,0 -12.22,5.5 -12.22,12.23 v 0 c 0,6.73 5.49,12.22 12.22,12.22 h 108.88 c 6.73,0 12.23,-5.49 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6261.31,5356.2 h -108.88 c -6.73,0 -12.22,5.5 -12.22,12.23 v 0 c 0,6.73 5.49,12.22 12.22,12.22 h 108.88 c 6.73,0 12.23,-5.49 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6186.74,5477.37 h -184.38 c -6.73,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.49,12.23 12.22,12.23 h 184.38 c 6.73,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.72 -5.5,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6434.16,5477.37 h -108.88 c -6.72,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.5,12.23 12.22,12.23 h 108.88 c 6.73,0 12.24,-5.5 12.24,-12.23 v 0 c 0,-6.72 -5.51,-12.22 -12.24,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6584.23,5477.37 h -108.88 c -6.73,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.49,12.23 12.22,12.23 h 108.88 c 6.73,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.72 -5.5,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6281.79,5477.37 h -55.72 c -6.72,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.5,12.23 12.22,12.23 h 55.72 c 6.73,0 12.22,-5.5 12.22,-12.23 v 0 c 0,-6.72 -5.49,-12.22 -12.22,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6210.45,5233.93 h -108.88 c -6.72,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.5,12.23 12.22,12.23 h 108.88 c 6.73,0 12.24,-5.5 12.24,-12.23 v 0 c 0,-6.72 -5.51,-12.22 -12.24,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6058.08,5233.93 h -55.72 c -6.73,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.49,12.23 12.22,12.23 h 55.72 c 6.72,0 12.22,-5.5 12.22,-12.23 v 0 c 0,-6.72 -5.5,-12.22 -12.22,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6312.61,5233.93 h -55.72 c -6.72,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.5,12.23 12.22,12.23 h 55.72 c 6.73,0 12.22,-5.5 12.22,-12.23 v 0 c 0,-6.72 -5.49,-12.22 -12.22,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6340.56,5111.65 h -184.39 c -6.72,0 -12.22,5.5 -12.22,12.23 v 0 c 0,6.72 5.5,12.22 12.22,12.22 h 184.39 c 6.73,0 12.22,-5.5 12.22,-12.22 v 0 c 0,-6.73 -5.49,-12.23 -12.22,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6111.24,5111.65 h -108.88 c -6.73,0 -12.22,5.5 -12.22,12.23 v 0 c 0,6.72 5.49,12.22 12.22,12.22 h 108.88 c 6.73,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6450.66,5111.65 h -55.71 c -6.73,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.5,12.22 12.23,12.22 h 55.71 c 6.73,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6490.86,5417.34 h -488.5 c -6.73,0 -12.22,5.5 -12.22,12.23 v 0 c 0,6.72 5.49,12.23 12.22,12.23 h 488.5 c 6.72,0 12.23,-5.51 12.23,-12.23 v 0 c 0,-6.73 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6490.86,5172.79 h -488.5 c -6.73,0 -12.22,5.5 -12.22,12.22 v 0 c 0,6.73 5.49,12.23 12.22,12.23 h 488.5 c 6.72,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.72 -5.51,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6388.97,5295.06 h -55.71 c -6.72,0 -12.22,5.51 -12.22,12.23 v 0 c 0,6.72 5.5,12.23 12.22,12.23 h 55.71 c 6.73,0 12.23,-5.51 12.23,-12.23 v 0 c 0,-6.72 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6542.25,5295.06 h -108.88 c -6.73,0 -12.23,5.51 -12.23,12.23 v 0 c 0,6.72 5.5,12.23 12.23,12.23 h 108.88 c 6.72,0 12.22,-5.51 12.22,-12.23 v 0 c 0,-6.72 -5.5,-12.23 -12.22,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6289.16,5295.06 h -286.8 c -6.73,0 -12.22,5.51 -12.22,12.23 v 0 c 0,6.72 5.49,12.23 12.22,12.23 h 286.8 c 6.72,0 12.23,-5.51 12.23,-12.23 v 0 c 0,-6.72 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 6886.05,5649.36 H 6040.4 c -27.65,0 -50.26,22.62 -50.26,50.26 v 0 c 0,27.65 22.61,50.27 50.26,50.27 h 845.65 c 27.65,0 50.27,-22.62 50.27,-50.27 v 0 c 0,-27.64 -22.62,-50.26 -50.27,-50.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6017.65,5706.35 c 0,15.26 12.37,27.62 27.62,27.62 15.26,0 27.62,-12.36 27.62,-27.62 0,-15.26 -12.36,-27.62 -27.62,-27.62 -15.25,0 -27.62,12.36 -27.62,27.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6026.93,5706.35 c 0,10.13 8.21,18.34 18.34,18.34 10.13,0 18.34,-8.21 18.34,-18.34 0,-10.13 -8.21,-18.34 -18.34,-18.34 -10.13,0 -18.34,8.21 -18.34,18.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6089.55,5663.43 -0.31,-0.36 c -1.88,-2.09 -5.12,-2.26 -7.21,-0.39 l -23.3,20.88 c -2.09,1.88 -2.27,5.12 -0.39,7.21 l 0.32,0.36 c 1.88,2.09 5.12,2.27 7.21,0.39 l 23.29,-20.89 c 2.09,-1.87 2.27,-5.11 0.39,-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5990.14,5579.18 c 0,14.77 11.96,26.73 26.73,26.73 14.76,0 26.72,-11.96 26.72,-26.73 0,-14.76 -11.96,-26.72 -26.72,-26.72 -14.77,0 -26.73,11.96 -26.73,26.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6070.3,5579.18 c 0,14.77 11.98,26.73 26.73,26.73 14.77,0 26.73,-11.96 26.73,-26.73 0,-14.76 -11.96,-26.72 -26.73,-26.72 -14.75,0 -26.73,11.96 -26.73,26.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6150.48,5579.18 c 0,14.77 11.96,26.73 26.73,26.73 14.75,0 26.73,-11.96 26.73,-26.73 0,-14.76 -11.98,-26.72 -26.73,-26.72 -14.77,0 -26.73,11.96 -26.73,26.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6230.64,5579.18 c 0,14.77 11.97,26.73 26.73,26.73 14.77,0 26.73,-11.96 26.73,-26.73 0,-14.76 -11.96,-26.72 -26.73,-26.72 -14.76,0 -26.73,11.96 -26.73,26.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6310.81,5579.18 c 0,14.77 11.97,26.73 26.73,26.73 14.76,0 26.73,-11.96 26.73,-26.73 0,-14.76 -11.97,-26.72 -26.73,-26.72 -14.76,0 -26.73,11.96 -26.73,26.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7851.45,5435.65 h -684.43 c -28.21,0 -51.3,23.08 -51.3,51.3 v 327.65 c 0,28.22 23.09,51.3 51.3,51.3 h 684.43 c 28.21,0 51.29,-23.08 51.29,-51.3 v -327.65 c 0,-28.22 -23.08,-51.3 -51.29,-51.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7902.73,5814.61 v -29.92 h -787 v 29.92 c 0,28.21 23.08,51.3 51.3,51.3 h 684.41 c 28.21,0 51.29,-23.09 51.29,-51.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7155.6,5825.3 c 0,7.87 6.38,14.25 14.24,14.25 7.87,0 14.26,-6.38 14.26,-14.25 0,-7.87 -6.39,-14.26 -14.26,-14.26 -7.86,0 -14.24,6.39 -14.24,14.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7206.98,5825.3 c 0,7.87 6.38,14.25 14.25,14.25 7.87,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.38,-14.26 -14.25,-14.26 -7.87,0 -14.25,6.39 -14.25,14.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7258.37,5825.3 c 0,7.87 6.38,14.25 14.25,14.25 7.87,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.38,-14.26 -14.25,-14.26 -7.87,0 -14.25,6.39 -14.25,14.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7242.05,5486.73 v 0 c -9.59,0 -17.44,7.85 -17.44,17.44 v 217.59 c 0,9.59 7.85,17.44 17.44,17.44 v 0 c 9.59,0 17.44,-7.85 17.44,-17.44 v -217.59 c 0,-9.59 -7.85,-17.44 -17.44,-17.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7272.21,5632.21 h -60.32 c -9.52,0 -17.3,7.79 -17.3,17.32 v 0 c 0,9.52 7.78,17.31 17.3,17.31 h 60.32 c 9.52,0 17.31,-7.79 17.31,-17.31 v 0 c 0,-9.53 -7.79,-17.32 -17.31,-17.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7374.57,5486.73 v 0 c -9.59,0 -17.43,7.85 -17.43,17.44 v 217.59 c 0,9.59 7.84,17.44 17.43,17.44 v 0 c 9.59,0 17.44,-7.85 17.44,-17.44 v -217.59 c 0,-9.59 -7.85,-17.44 -17.44,-17.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7404.73,5589.46 h -60.31 c -9.52,0 -17.31,7.8 -17.31,17.32 v 0 c 0,9.52 7.79,17.31 17.31,17.31 h 60.31 c 9.52,0 17.31,-7.79 17.31,-17.31 v 0 c 0,-9.52 -7.79,-17.32 -17.31,-17.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7507.1,5486.73 v 0 c -9.6,0 -17.44,7.85 -17.44,17.44 v 217.59 c 0,9.59 7.84,17.44 17.44,17.44 v 0 c 9.59,0 17.43,-7.85 17.43,-17.44 v -217.59 c 0,-9.59 -7.84,-17.44 -17.43,-17.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7537.25,5662.14 h -60.31 c -9.52,0 -17.31,7.79 -17.31,17.31 v 0 c 0,9.52 7.79,17.31 17.31,17.31 h 60.31 c 9.52,0 17.31,-7.79 17.31,-17.31 v 0 c 0,-9.52 -7.79,-17.31 -17.31,-17.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7639.62,5486.73 v 0 c -9.59,0 -17.44,7.85 -17.44,17.44 v 217.59 c 0,9.59 7.85,17.44 17.44,17.44 v 0 c 9.59,0 17.43,-7.85 17.43,-17.44 v -217.59 c 0,-9.59 -7.84,-17.44 -17.43,-17.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7669.77,5529.61 h -60.31 c -9.52,0 -17.31,7.8 -17.31,17.32 v 0 c 0,9.52 7.79,17.31 17.31,17.31 h 60.31 c 9.53,0 17.31,-7.79 17.31,-17.31 v 0 c 0,-9.52 -7.78,-17.32 -17.31,-17.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7776.42,5486.73 v 0 c -9.59,0 -17.45,7.85 -17.45,17.44 v 217.59 c 0,9.59 7.86,17.44 17.45,17.44 v 0 c 9.59,0 17.43,-7.85 17.43,-17.44 v -217.59 c 0,-9.59 -7.84,-17.44 -17.43,-17.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7806.56,5662.14 h -60.3 c -9.52,0 -17.31,7.79 -17.31,17.31 v 0 c 0,9.52 7.79,17.31 17.31,17.31 h 60.3 c 9.53,0 17.32,-7.79 17.32,-17.31 v 0 c 0,-9.52 -7.79,-17.31 -17.32,-17.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7855.21,4682.41 h -688.08 c -27.33,0 -49.68,22.36 -49.68,49.68 V 5289 c 0,27.32 22.35,49.68 49.68,49.68 h 688.08 c 27.32,0 49.67,-22.36 49.67,-49.68 v -556.91 c 0,-27.32 -22.35,-49.68 -49.67,-49.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    style: {
      fill: "#d9dbee",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7904.86,5289 v -30.6 h -787.43 v 30.6 c 0,27.32 22.36,49.68 49.72,49.68 h 688.05 c 27.31,0 49.66,-22.36 49.66,-49.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7155.76,5295.06 c 0,7.87 6.38,14.25 14.25,14.25 7.87,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.38,-14.24 -14.25,-14.24 -7.87,0 -14.25,6.37 -14.25,14.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7207.15,5295.06 c 0,7.87 6.38,14.25 14.25,14.25 7.87,0 14.24,-6.38 14.24,-14.25 0,-7.87 -6.37,-14.24 -14.24,-14.24 -7.87,0 -14.25,6.37 -14.25,14.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    style: {
      fill: "#a8b9d5",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7258.53,5295.06 c 0,7.87 6.38,14.25 14.25,14.25 7.86,0 14.25,-6.38 14.25,-14.25 0,-7.87 -6.39,-14.24 -14.25,-14.24 -7.87,0 -14.25,6.37 -14.25,14.24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,5185.01 h -26.64 c -6.72,0 -12.23,5.51 -12.23,12.23 v 0 c 0,6.72 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.51 12.23,-12.23 v 0 c 0,-6.72 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,5130.51 h -26.64 c -6.72,0 -12.23,5.5 -12.23,12.22 v 0.01 c 0,6.72 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.51 12.23,-12.23 v -0.01 c 0,-6.72 -5.51,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,5076.01 h -26.64 c -6.72,0 -12.23,5.49 -12.23,12.22 v 0 c 0,6.73 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.73 -5.51,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,5021.5 h -26.64 c -6.72,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.51,12.22 12.23,12.22 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,4966.99 h -26.64 c -6.72,0 -12.23,5.51 -12.23,12.23 v 0 c 0,6.73 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.72 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,4912.49 h -26.64 c -6.72,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.51,12.22 12.23,12.22 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,4857.98 h -26.64 c -6.72,0 -12.23,5.51 -12.23,12.23 v 0 c 0,6.73 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.72 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,4803.48 h -26.64 c -6.72,0 -12.23,5.5 -12.23,12.22 v 0.01 c 0,6.72 5.51,12.22 12.23,12.22 h 26.64 c 6.72,0 12.23,-5.5 12.23,-12.22 v -0.01 c 0,-6.72 -5.51,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7194.92,4748.97 h -26.64 c -6.72,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.51,12.23 12.23,12.23 h 26.64 c 6.72,0 12.23,-5.51 12.23,-12.23 v 0 c 0,-6.73 -5.51,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7341.46,5076.01 h -108.87 c -6.73,0 -12.23,5.49 -12.23,12.22 v 0 c 0,6.73 5.5,12.23 12.23,12.23 h 108.87 c 6.73,0 12.23,-5.5 12.23,-12.23 v 0 c 0,-6.73 -5.5,-12.22 -12.23,-12.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7341.46,5021.5 h -108.87 c -6.73,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.5,12.22 12.23,12.22 h 108.87 c 6.73,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7341.46,4803.48 h -108.87 c -6.73,0 -12.23,5.5 -12.23,12.23 v 0 c 0,6.72 5.5,12.22 12.23,12.22 h 108.87 c 6.73,0 12.23,-5.5 12.23,-12.22 v 0 c 0,-6.73 -5.5,-12.23 -12.23,-12.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    style: {
      fill: "#995c7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3276.94,3974.55 h 83.12 c 29.3,0 53.28,23.99 53.28,53.31 v 148.81 c 0,29.3 -23.98,53.28 -53.28,53.28 h -84.76 c -0.5,14.98 -0.87,29.96 -0.99,44.93 h 118.03 c 38.24,0 69.52,-31.28 69.52,-69.5 v -206.26 c 0,-38.22 -31.28,-69.5 -69.52,-69.5 h -121.31 c 2.52,14.95 4.46,29.93 5.91,44.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path296",
    style: {
      fill: "#7a3d5f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3319.37,4332.43 v -453.42 c 0,-23.28 -16.42,-42.36 -36.45,-42.36 h -333.71 c -20.03,0 -36.45,19.08 -36.45,42.36 v 453.42 c 0,23.32 16.42,42.36 36.45,42.36 h 333.71 c 20.03,0 36.45,-19.04 36.45,-42.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path298",
    style: {
      fill: "#995c7d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3325.21,4332.43 v -453.42 c 0,-23.28 -16.42,-42.36 -36.45,-42.36 h -235.05 c -20.03,0 -36.44,19.08 -36.44,42.36 v 453.42 c 0,23.32 16.41,42.36 36.44,42.36 h 235.05 c 20.03,0 36.45,-19.04 36.45,-42.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path300",
    style: {
      fill: "#4eb3af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9227.98,5522.5 c -138.35,-252.87 -189.47,-549.53 -144.66,-834.2 3.74,-23.8 40.87,-18.66 37.11,5.22 -43.89,278.78 6.79,567.22 142.23,814.76 11.58,21.16 -23.23,35.16 -34.68,14.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path302",
    style: {
      fill: "#ffe989",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9407.09,5581.02 c 6.7,10.34 11.62,21.6 12.84,33.92 2.28,23.07 -10.55,44.05 -31.96,52.68 -37.5,15.11 -67.97,-5.34 -90.93,-32.59 -8.08,23.4 -20.93,45.27 -42.5,58.64 -22.77,14.1 -53.49,15.78 -77.14,2.81 -31.41,-17.22 -37.58,-58.51 -20.84,-85.37 -20.38,-1.9 -40.36,-6.36 -58.1,-17.15 -22.84,-13.89 -40.14,-39.59 -39.86,-66.9 0.28,-27.16 19.42,-48.63 44.54,-56.94 22.35,-7.38 44.78,-4.25 66.46,2.41 -13.99,-51.65 20.86,-109.64 80.15,-112.07 53.67,-2.2 93.36,43.77 91.42,92.39 1.4,4.09 2.62,8.25 3.57,12.53 18.49,-4.21 37.65,-4.58 55.93,1.88 24.21,8.57 44.79,31.37 47.65,57.34 3.06,27.79 -17.4,50.62 -41.23,56.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path304",
    style: {
      fill: "#f2b263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9277.87,5580.98 c -17.96,0 -34.81,-9.27 -37.32,-28.73 -2.07,-16.03 10.63,-37.32 28.73,-37.32 17.96,0 34.8,9.27 37.32,28.73 2.07,16.03 -10.63,37.32 -28.73,37.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9363.49,4258.96 c 0,-212.74 -123.45,-385.19 -275.73,-385.19 -152.27,0 -275.71,172.45 -275.71,385.19 0,212.72 123.44,385.18 275.71,385.18 152.28,0 275.73,-172.46 275.73,-385.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9166.24,4977.48 v -601.55 c 0,-44.37 -26,-80.69 -57.75,-80.69 h -41.46 c -31.77,0 -57.71,36.32 -57.71,80.69 v 601.55 c 0,44.37 25.94,80.68 57.71,80.68 h 41.46 c 31.75,0 57.75,-36.31 57.75,-80.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9273.98,3915.41 c 0,-7.85 -0.88,-15.44 -2.48,-22.64 -2.67,-11.72 -7.3,-22.18 -13.39,-30.76 -9.84,-13.67 -23.38,-22.19 -38.23,-22.19 h -264.25 c -24.13,0 -44.64,22.39 -51.58,52.95 -1.59,7.2 -2.48,14.79 -2.48,22.64 0,20.81 6.1,39.66 15.88,53.34 9.8,13.67 23.28,22.19 38.18,22.19 h 264.25 c 29.75,0 54.1,-33.97 54.1,-75.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 9168.23,4960.74 H 9007.3 c -31.1,0 -56.56,25.45 -56.56,56.55 v 20.59 c 0,31.1 25.46,56.55 56.56,56.55 h 160.93 c 31.11,0 56.56,-25.45 56.56,-56.55 v -20.59 c 0,-31.1 -25.45,-56.55 -56.56,-56.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9273.98,3915.41 c 0,-7.85 -0.88,-15.44 -2.48,-22.64 h -367.45 c -1.59,7.2 -2.48,14.79 -2.48,22.64 0,20.81 6.1,39.66 15.88,53.34 9.8,13.67 23.28,22.19 38.18,22.19 h 264.25 c 29.75,0 54.1,-33.97 54.1,-75.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9166.24,4960.72 v -46.98 h -156.92 v 46.98 h 156.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9017.09,3905.09 c -7.91,72.73 -7.38,146.93 -6.9,220.32 0.7,109.85 9.86,219.14 21.12,327.74 6.49,62.66 13.84,125.13 20.81,187.67 -135.43,-24.44 -240.07,-186.03 -240.07,-381.86 0,-179.84 88.22,-330.87 207.5,-373.29 -0.92,6.49 -1.76,12.96 -2.46,19.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9031.31,4453.15 c 11.36,109.6 25.37,218.63 35.29,328.52 8.32,92.14 14.32,185.26 2.44,276.49 h -2.01 c -31.77,0 -57.71,-36.31 -57.71,-80.68 v -601.55 c 0,-17.13 3.89,-33.03 10.47,-46.14 3.32,41.22 7.26,82.34 11.52,123.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9017.09,3905.09 c -3.1,28.44 -4.87,57.1 -5.89,85.85 h -55.57 c -14.9,0 -28.38,-8.52 -38.18,-22.19 -9.78,-13.68 -15.88,-32.53 -15.88,-53.34 0,-7.85 0.89,-15.44 2.48,-22.64 6.94,-30.56 27.45,-52.95 51.58,-52.95 h 72.4 c -5.01,21.35 -8.57,43.45 -10.94,65.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9063.3,5094.43 h -64.71 c -26.31,0 -47.85,-30.08 -47.85,-66.84 0,-36.77 21.54,-66.85 47.85,-66.85 h 77.05 c -0.55,44.88 -4.1,89.56 -12.34,133.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9017.09,3905.09 c -3.1,28.44 -4.87,57.1 -5.89,85.85 h -55.57 c -14.9,0 -28.38,-8.52 -38.18,-22.19 -9.78,-13.68 -15.88,-32.53 -15.88,-53.34 0,-7.85 0.89,-15.44 2.48,-22.64 h 114.52 c -0.52,4.11 -1.03,8.22 -1.48,12.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 9075.64,4960.72 h -66.32 v -46.98 h 65.9 c 0.44,15.67 0.62,31.34 0.42,46.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8766.51,3957.81 -34.34,-4.46 c -6.76,-0.87 -13.12,4.67 -14.11,12.4 l -94.57,729.09 c -0.64,4.86 3.9,60.22 7.33,100.37 1.96,23.44 3.58,41.65 3.58,41.65 0,0 6.38,-17.17 14.49,-39.31 13.9,-37.9 32.86,-90.22 33.48,-95.07 l 94.57,-729.09 c 1.01,-7.74 -3.72,-14.71 -10.43,-15.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    style: {
      fill: "#f2b263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8778.96,3957.88 -96.19,741.53 -58.86,-7.64 96.18,-741.53 c 1.11,-8.54 9,-14.62 17.55,-13.52 l 27.79,3.61 c 8.55,1.11 14.64,9.01 13.53,17.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8779.33,3954.99 -4.08,31.47 -58.87,-7.63 4.08,-31.47 c 2.03,-15.6 16.44,-26.71 32.05,-24.68 l 2.14,0.27 c 15.59,2.02 26.71,16.44 24.68,32.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8776.37,3977.81 -1.12,8.65 -58.87,-7.63 1.12,-8.64 c 0.14,-1.01 1.06,-1.73 2.07,-1.6 l 55.22,7.16 c 0.99,0.13 1.71,1.07 1.58,2.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8648.89,4797.55 -18.07,-2.34 c 1.96,23.44 3.58,41.65 3.58,41.65 0,0 6.38,-17.17 14.49,-39.31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8818.47,4700.06 31.92,-6.42 c 6.29,-1.26 10.26,-8.11 8.82,-15.3 l -136.23,-677.73 c -0.91,-4.52 -21.68,-52.44 -36.88,-87.14 -8.83,-20.29 -15.78,-36.01 -15.78,-36.01 0,0 -0.49,17.22 -1,39.39 -0.93,37.94 -1.99,90.24 -1.08,94.76 l 136.22,677.73 c 1.45,7.19 7.77,11.97 14.01,10.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    style: {
      fill: "#f2b263",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8807.36,4703.76 -138.55,-689.3 54.73,-10.99 138.55,689.29 c 1.59,7.94 -3.6,15.75 -11.54,17.35 l -25.84,5.19 c -7.94,1.59 -15.75,-3.6 -17.35,-11.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8807.9,4706.44 -5.88,-29.25 54.73,-11 5.88,29.25 c 2.91,14.51 -6.58,28.75 -21.08,31.67 l -1.98,0.4 c -14.5,2.91 -28.75,-6.57 -31.67,-21.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8803.64,4685.23 -1.62,-8.04 54.73,-11 1.61,8.04 c 0.18,0.93 -0.42,1.85 -1.36,2.04 l -51.32,10.32 c -0.93,0.18 -1.85,-0.43 -2.04,-1.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8669.32,3916.85 16.78,-3.38 c -8.83,-20.29 -15.78,-36.01 -15.78,-36.01 0,0 -0.49,17.22 -1,39.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8640.56,4056.63 v 0 c -2.65,-0.17 -4.94,1.87 -5.11,4.51 l -6.1,98.99 c -0.17,2.64 1.86,4.94 4.51,5.1 v 0 c 2.64,0.17 4.94,-1.86 5.1,-4.51 l 6.12,-98.98 c 0.15,-2.65 -1.88,-4.95 -4.52,-5.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8638.54,4089.49 v 0 c -13.63,-0.84 -25.45,9.62 -26.29,23.23 l -33.81,547.83 c -0.84,13.62 9.61,25.44 23.22,26.28 v 0 c 13.61,0.84 25.44,-9.61 26.28,-23.22 l 33.82,-547.83 c 0.84,-13.62 -9.61,-25.45 -23.22,-26.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8601.46,4673.5 v 0 c -7.5,-0.47 -14.01,5.29 -14.48,12.78 l -4.13,67 c -0.46,7.49 5.29,14 12.78,14.46 v 0 c 7.5,0.47 14.02,-5.29 14.48,-12.78 l 4.13,-67 c 0.47,-7.49 -5.28,-14 -12.78,-14.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    style: {
      fill: "#7a3d5f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8641.56,4422.48 -49.03,-3.03 c -4.5,-0.28 -8.4,3.18 -8.68,7.67 l -16.98,275.21 c -1.12,17.98 12.68,33.6 30.66,34.71 v 0 c 17.98,1.11 33.6,-12.69 34.71,-30.67 l 16.99,-275.22 c 0.27,-4.49 -3.18,-8.4 -7.67,-8.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8633.01,4660.07 -61.21,-3.78 c -3.52,-0.21 -6.57,2.48 -6.78,6 l -0.16,2.53 c -0.22,3.52 2.47,6.57 5.99,6.79 l 61.21,3.78 c 3.52,0.21 6.56,-2.48 6.78,-6 l 0.15,-2.53 c 0.22,-3.52 -2.48,-6.57 -5.98,-6.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8634.37,4638.1 -61.22,-3.78 c -3.51,-0.22 -6.56,2.48 -6.77,5.99 l -0.17,2.54 c -0.21,3.51 2.48,6.56 6,6.78 l 61.21,3.77 c 3.5,0.22 6.56,-2.47 6.78,-5.99 l 0.15,-2.54 c 0.22,-3.51 -2.48,-6.56 -5.98,-6.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    style: {
      fill: "#5a95bd",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8889.45,4519.65 v -644.99 c 0,-20.62 -16.86,-37.48 -37.48,-37.48 h -277.51 c -20.6,0 -37.47,16.86 -37.47,37.48 v 644.99 c 0,20.61 16.87,37.48 37.47,37.48 h 277.51 c 20.62,0 37.48,-16.87 37.48,-37.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    style: {
      fill: "#9abfdb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 8889.45,4519.65 v -644.99 c 0,-20.62 -16.86,-37.48 -37.48,-37.48 h -210.38 v 719.95 h 210.38 c 20.62,0 37.48,-16.87 37.48,-37.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5079.95,5025 h -255.02 c -30.92,0 -56.21,25.29 -56.21,56.21 v 532.98 c 0,30.92 25.29,56.22 56.21,56.22 h 255.02 c 30.92,0 56.21,-25.3 56.21,-56.22 v -532.98 c 0,-30.92 -25.29,-56.21 -56.21,-56.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    style: {
      fill: "#e46758",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5136.18,5306.64 v -142.88 c -126.89,49.29 -348.74,265.61 -367.44,366.94 v 83.47 c 0,12.65 4.26,24.41 11.38,33.82 25.02,-48.24 44.03,-78.08 44.03,-78.08 l 18.42,-21.04 c 33.68,-96.64 166.05,-193.19 293.61,-242.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5294.86,5273.45 c -148.28,-3.89 -403.58,135.62 -452.28,275.41 l -18.44,21.05 c 0,0 -311.78,488.49 -69.13,708.14 56.21,50.88 145.88,41.41 221.67,42.39 l 86.01,1.13 c 210.89,2.86 385.39,-138.57 387.82,-314.19 l 1.64,-121.37 2.29,-170.84 c 0,0 -1.74,-437.57 -159.58,-441.72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4769.63,5617.59 c 0,0 -0.89,-0.93 -1.17,-0.84 -0.33,0.09 -0.52,0.19 -0.61,0.28 -0.1,0.09 0,0.19 0.24,0.28 0.27,0.1 0.79,0.23 1.54,0.28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5436.6,5804.72 c 69.25,-45.05 109.43,-106.12 89.72,-136.42 -19.71,-30.3 -91.83,-18.34 -161.09,26.7 -69.25,45.04 -109.42,106.12 -89.71,136.42 19.7,30.3 91.82,18.35 161.08,-26.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    style: {
      fill: "#191b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4798.11,6314.71 c 0,0 -221.54,0.74 -268.59,-29.16 -73.69,-46.84 -106.44,-133.76 -87.96,-214.28 0.02,-0.23 0.02,-0.44 0.04,-0.67 l 0.46,-1.35 c 2.78,-11.57 6.58,-23 11.52,-34.16 l 104.3,-309.08 c 22.93,-146.89 121.45,-206.05 213.74,-205.1 0,0 164.85,9.08 169.72,208.74 l 26.74,350.6 c -1.19,129.91 -77.67,235.41 -169.97,234.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5319.47,5531.12 124.44,-14.9 c 15.28,-1.83 29.28,9.17 31.14,24.44 v 0 c 1.84,15.27 -9.14,29.26 -24.42,31.09 l -124.43,14.9 c -15.27,1.83 -29.29,-9.17 -31.14,-24.44 v 0 c -1.85,-15.27 9.14,-29.26 24.41,-31.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5302.96,5485.22 124.43,-14.9 c 15.29,-1.83 29.29,9.17 31.15,24.44 v 0 c 1.84,15.27 -9.15,29.26 -24.42,31.09 l -124.43,14.9 c -15.28,1.83 -29.29,-9.17 -31.15,-24.44 v 0 c -1.84,-15.27 9.15,-29.26 24.42,-31.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    style: {
      fill: "#191b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4905.99,5808.75 h -76.47 c -40.52,0 -73.66,33.15 -73.66,73.66 v 457.45 c 0,40.51 33.14,73.66 73.66,73.66 h 143 c 40.51,0 73.65,-33.15 73.65,-73.66 v -390.92 c 0,-77.1 -63.08,-140.19 -140.18,-140.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5433.16,5878.39 c 7,44.37 -23.3,86.01 -67.67,93.01 -44.38,6.99 -86.02,-23.3 -93.01,-67.67 -7,-44.37 23.3,-86.02 67.68,-93.01 44.36,-7 86,23.3 93,67.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    style: {
      fill: "#4994f0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5432.09,5872.98 c 4.71,29.88 -15.69,57.91 -45.57,62.62 -29.87,4.71 -57.9,-15.69 -62.61,-45.56 -4.71,-29.87 15.69,-57.91 45.56,-62.61 29.88,-4.72 57.9,15.69 62.62,45.55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    style: {
      fill: "#002539",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5429.5,5873.41 c 3.64,23.15 -12.16,44.86 -35.3,48.51 -23.14,3.65 -44.85,-12.15 -48.51,-35.29 -3.64,-23.14 12.16,-44.86 35.3,-48.51 23.14,-3.65 44.86,12.15 48.51,35.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5349.09,5901.38 c 0.22,1.34 5.97,1.56 12.86,0.47 6.89,-1.08 12.3,-3.06 12.09,-4.4 -0.21,-1.36 -5.97,-1.57 -12.86,-0.48 -6.89,1.09 -12.3,3.06 -12.09,4.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5379.21,5883.2 c 0.21,1.39 -0.74,2.71 -2.14,2.93 -1.4,0.22 -2.7,-0.74 -2.93,-2.14 -0.21,-1.39 0.73,-2.71 2.13,-2.93 1.41,-0.22 2.71,0.74 2.94,2.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5421.53,5898.32 -209.49,-22.9 c -17.62,-1.93 -33.61,10.9 -35.54,28.52 l -3.69,33.77 c -1.92,17.62 10.91,33.6 28.53,35.53 l 209.49,22.9 c 17.62,1.93 33.6,-10.91 35.54,-28.52 l 3.69,-33.77 c 1.92,-17.62 -10.92,-33.61 -28.53,-35.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    style: {
      fill: "#191b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5268.57,5946.07 166.36,18.19 c 15.25,1.67 26.35,15.5 24.68,30.74 l -0.48,4.4 c -1.67,15.24 -15.5,26.34 -30.73,24.68 l -166.37,-18.19 c -15.23,-1.67 -26.34,-15.5 -24.68,-30.73 l 0.48,-4.41 c 1.67,-15.24 15.5,-26.34 30.74,-24.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4904.28,5665.86 -3.16,-0.03 c -46.98,-0.48 -85.75,37.54 -86.17,84.49 l -0.03,3.16 c -0.42,46.94 37.67,85.74 84.65,86.22 l 3.15,0.03 c 46.98,0.48 85.76,-37.54 86.18,-84.49 l 0.03,-3.16 c 0.42,-46.94 -37.68,-85.74 -84.65,-86.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    style: {
      fill: "#e46758",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4903.03,5711.87 -1.49,-0.01 c -22.11,-0.22 -40.35,17.67 -40.54,39.76 l -0.02,1.49 c -0.2,22.09 17.73,40.35 39.83,40.57 l 1.48,0.02 c 22.11,0.22 40.37,-17.67 40.56,-39.76 l 0.01,-1.49 c 0.2,-22.09 -17.72,-40.35 -39.83,-40.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    style: {
      fill: "#191b2a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5006.23,6549 c -82.11,-19.47 -161.59,-46.12 -196.67,-58.4 -10.36,-3.63 -20.79,-7.1 -31.29,-10.33 -108.07,-33.21 -174.65,-108.02 -167.67,-217.65 l 2.52,-39.63 c 2.97,-46.66 41.05,-82.18 84.62,-78.95 l 732.16,-41.06 c 0,0 269.83,13.43 227.9,410.05 -7.98,-5.23 -120.22,-41.29 -210.92,-54.31 -37.12,-5.33 -87.3,31.83 -132.19,59.57 -91.46,56.53 -203.84,55.52 -308.46,30.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    style: {
      fill: "#e27e6a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5942.4,2577.24 6046.17,2526 c 76.63,-37.86 108.38,-131.52 70.53,-208.16 l -473.77,-959.41 c -12.38,-25.09 -43.06,-35.48 -68.14,-23.09 l -243.12,120.05 542.58,1098.75 c 12.39,25.1 43.05,35.49 68.15,23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    style: {
      fill: "#302e46",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6026.72,890.629 c -1.73,-3.969 -4.94,-6.949 -8.66,-8.43 -3.74,-1.551 -8.02,-1.648 -12.04,0.043 l -764.84,326.828 -101.7,43.44 c -10.27,4.38 -15.06,16.44 -10.64,26.78 l 50.62,118.52 c 7.56,17.67 20.95,41.27 38.8,62.56 6.64,8.01 13.9,15.64 21.73,22.58 32.13,28.37 77.95,34.78 117.08,18.09 l 514.4,-219.81 c 149.81,-64.03 219.63,-239.79 155.25,-390.601"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6000.48,854.141 -881.85,370.609 c -18.61,7.81 -27.43,29.43 -19.62,48.04 v 0 c 7.83,18.61 29.45,27.42 48.05,19.61 l 881.85,-370.599 c 18.61,-7.832 27.43,-29.449 19.62,-48.051 v 0 c -7.83,-18.598 -29.45,-27.43 -48.05,-19.609"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5619.37,1296.97 v 0 c 7.48,-6.21 18.74,-4.69 25.01,3.37 l 41.05,52.68 c 6.29,8.06 5.31,19.75 -2.17,25.96 v 0 c -7.47,6.22 -18.73,4.7 -25.02,-3.36 l -41.04,-52.68 c -6.28,-8.07 -5.31,-19.76 2.17,-25.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5685.55,1268.67 v 0 c 7.47,-6.21 18.73,-4.7 25.02,3.37 l 41.04,52.69 c 6.28,8.06 5.3,19.74 -2.17,25.95 v 0 c -7.48,6.22 -18.74,4.7 -25.02,-3.36 l -41.04,-52.68 c -6.29,-8.07 -5.31,-19.75 2.17,-25.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    style: {
      fill: "#feeded",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5751.72,1240.37 v 0 c 7.48,-6.21 18.73,-4.7 25.02,3.37 l 41.04,52.69 c 6.28,8.06 5.32,19.74 -2.16,25.95 v 0 c -7.48,6.22 -18.74,4.71 -25.02,-3.36 l -41.05,-52.68 c -6.28,-8.07 -5.31,-19.75 2.17,-25.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    style: {
      fill: "#302e46",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4642.08,2805.26 v 414.45 c 0,14.66 11.99,26.66 26.65,26.66 h 1673.16 c 90.19,0 163.98,-73.79 163.98,-163.98 v -89.04 c 0,-118.11 -96.63,-214.75 -214.75,-214.75 H 4668.73 c -14.66,0 -26.65,12.01 -26.65,26.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6480.57,2455.04 244.4,-3.07 c 29.5,-0.37 53.37,-22.53 53.04,-49.24 l -15.58,-1240.99 -339.58,4.44 -0.56,1237.42 c 0.36,28.69 26.59,51.84 58.28,51.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path420",
    style: {
      fill: "#302e46",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5365.54,1591.07 373.77,-183.56 c 12.67,-6.23 28.14,-0.95 34.36,11.73 l 681.15,1386.97 c 38.3,77.97 5.83,173.09 -72.12,211.37 l -255.07,125.26 c -12.68,6.23 -28.14,0.95 -34.37,-11.73 L 5353.81,1625.43 c -6.22,-12.68 -0.95,-28.14 11.73,-34.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path422",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4879.61,2723.99 v 434.4 c 0,15.46 12.66,28.11 28.11,28.11 h 1776.06 c 95.13,0 172.97,-77.83 172.97,-172.96 v -91.15 c 0,-124.58 -101.94,-226.51 -226.53,-226.51 h -1722.5 c -15.45,0 -28.11,12.66 -28.11,28.11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path424",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6371.92,1343.67 441.8,-4.59 c 14.52,-0.14 26.52,11.61 26.67,26.13 l 16.36,1575.88 c 0.71,69.53 -55.59,127.03 -125.13,127.75 l -341.76,3.54 c -14.52,0.16 -26.52,-11.6 -26.67,-26.12 L 6345.8,1370.34 c -0.15,-14.52 11.6,-26.52 26.12,-26.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path426",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4651.64,2693.99 h 546.18 c 88.97,0 161.76,110.53 161.76,245.62 l -5.53,445.25 h -864.52 l 0.35,-445.25 c 0,-135.09 72.8,-245.62 161.76,-245.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path428",
    style: {
      fill: "#4eb3af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4457.9,2984.45 900.2,202.41 c 7.83,-0.23 14.42,8.08 14.71,18.56 l 42.51,1533.83 c 7.51,270.84 -150.74,494.96 -353.46,500.58 l -290.98,-3.56 c -176.91,4.91 -250.96,-173.17 -257.5,-409.52 l -55.48,-1842.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path430",
    style: {
      fill: "#403e55",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7299.38,908.199 c -0.04,-4.328 -1.85,-8.32 -4.7,-11.129 -2.85,-2.871 -6.76,-4.629 -11.13,-4.629 l -831.71,4.981 -110.59,0.648 c -11.17,0.051 -20.25,9.309 -20.2,20.559 l 0.76,128.881 c 0.11,19.22 3.32,46.16 11.53,72.7 3.02,9.97 6.75,19.8 11.29,29.23 18.62,38.62 58.38,62.28 100.92,62.04 l 559.39,-3.34 c 162.91,-0.99 295.38,-135.96 294.44,-299.941"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path432",
    style: {
      fill: "#fcfeff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 7289.34,864.379 h -956.57 c -20.17,0 -36.69,16.523 -36.69,36.699 v 0 c 0,20.192 16.52,36.703 36.69,36.703 h 956.57 c 20.18,0 36.7,-16.511 36.7,-36.703 v 0 c 0,-20.176 -16.52,-36.699 -36.7,-36.699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path434",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6766.43,1124.98 v 0 c 9.29,-2.83 19.09,2.93 21.75,12.8 l 17.44,64.47 c 2.66,9.87 -2.77,20.26 -12.07,23.09 v 0 c -9.29,2.83 -19.09,-2.92 -21.75,-12.79 l -17.43,-64.47 c -2.67,-9.87 2.75,-20.27 12.06,-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path436",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6838.4,1124.53 v 0 c 9.3,-2.83 19.09,2.93 21.76,12.8 l 17.43,64.47 c 2.66,9.87 -2.77,20.26 -12.06,23.09 v 0 c -9.3,2.83 -19.09,-2.92 -21.76,-12.79 l -17.43,-64.47 c -2.67,-9.88 2.75,-20.27 12.06,-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path438",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6910.36,1124.08 v 0 c 9.31,-2.83 19.09,2.93 21.77,12.79 l 17.42,64.48 c 2.68,9.87 -2.75,20.26 -12.05,23.09 v 0 c -9.31,2.84 -19.09,-2.93 -21.77,-12.79 l -17.42,-64.47 c -2.68,-9.88 2.75,-20.27 12.05,-23.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6996.97,4069.18 c -164.53,-1.46 -301.92,-83.21 -339.62,-192.44 -9.46,-27.42 19.76,-53.75 59.27,-53.4 l 565.07,4.98 c 39.51,0.34 68.27,27.19 58.31,54.44 -39.63,108.55 -178.5,187.86 -343.03,186.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    style: {
      fill: "#f6977a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6884.8,4176.31 c -153.65,-22.72 -267.86,-141.54 -284.02,-281.76 -4.06,-35.2 27.88,-64.12 64.78,-58.67 l 527.68,78.02 c 36.9,5.46 59.1,42.38 45.03,74.91 -56.05,129.53 -199.82,210.21 -353.47,187.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path444",
    style: {
      fill: "#fb947b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6626.67,3836.04 -1128.54,100.39 25.45,286.09 1335.1,-166.62 -78.28,-138.94 c -30.89,-54.83 -91.03,-86.49 -153.73,-80.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path446",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5463.72,3935.04 137.45,94.92 c 48.95,33.8 61.34,101.5 27.54,150.43 l -624.28,904 c -33.8,48.94 -101.49,61.33 -150.44,27.53 l -24.67,-17.04 c -110.97,-76.63 -139.07,-230.12 -62.44,-341.09 l 546.4,-791.22 c 33.8,-48.94 101.5,-61.33 150.44,-27.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    style: {
      fill: "#78dbbe",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6589.25,4093.21 -37.29,-321.81 c -1.26,-10.78 -11.1,-18.46 -21.82,-17.05 l -132.57,17.47 -73.08,9.64 -87.74,11.53 -72.98,9.65 -87.74,11.57 -73.08,9.6 -591.55,78 c -64.89,8.57 -111.96,64.93 -104.65,125.21 l 16.81,138.95 c 7.31,60.28 66.33,102.63 131.22,94.11 l 596.84,-77.63 73.08,-9.51 87.78,-11.43 73.04,-9.46 87.73,-11.43 73.08,-9.51 126.15,-16.39 c 10.54,-1.36 17.99,-10.96 16.77,-21.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path450",
    style: {
      fill: "#4eb3af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6446.33,4131.11 -48.76,-359.29 -73.08,9.64 48.76,359.16 73.08,-9.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path452",
    style: {
      fill: "#4eb3af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6285.52,4152.05 -48.77,-359.06 -72.98,9.65 48.71,358.87 73.04,-9.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path454",
    style: {
      fill: "#4eb3af",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6124.7,4172.94 -48.67,-358.73 -73.08,9.6 48.67,358.64 73.08,-9.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path456",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4720.66,2387.17 h -257.44 c -265.58,0 -480.89,200.19 -480.89,447.14 v 2091.51 c 0,59.86 52.2,108.39 116.59,108.39 h 505.16 c 64.39,0 116.58,-48.53 116.58,-108.39 V 3117.35 c 0,-103.98 63.93,-198.82 164.58,-244.15 l 111.49,-50.2 -276.07,-435.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path458",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5137.89,947.02 h 0.01 c 77.64,0 141.16,63.53 141.16,141.16 v 865.04 c 0,77.65 -63.52,141.17 -141.16,141.17 h -0.01 c -77.64,0 -141.16,-63.52 -141.16,-141.17 v -865.04 c 0,-77.63 63.52,-141.16 141.16,-141.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path460",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4482.44,782.281 c 0,74.028 -60.02,134.051 -134.04,134.051 -74.03,0 -134.05,-60.023 -134.05,-134.051 0,-74.039 60.02,-134.051 134.05,-134.051 74.02,0 134.04,60.012 134.04,134.051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path462",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5017.58,782.281 c 0,74.028 -60.02,134.051 -134.05,134.051 -74.03,0 -134.05,-60.023 -134.05,-134.051 0,-74.039 60.02,-134.051 134.05,-134.051 74.03,0 134.05,60.012 134.05,134.051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path464",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5552.71,782.281 c 0,74.028 -60.01,134.051 -134.05,134.051 -74.03,0 -134.04,-60.023 -134.04,-134.051 0,-74.039 60.01,-134.051 134.04,-134.051 74.04,0 134.05,60.012 134.05,134.051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path466",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6087.84,782.281 c 0,74.028 -60.01,134.051 -134.04,134.051 -74.03,0 -134.04,-60.023 -134.04,-134.051 0,-74.039 60.01,-134.051 134.04,-134.051 74.03,0 134.04,60.012 134.04,134.051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path468",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4366.16,832.73 H 5931.5 c 78.28,0 142.31,64.04 142.31,142.309 v 0 c 0,78.261 -64.03,142.291 -142.31,142.291 H 4366.16 c -78.26,0 -142.29,-64.03 -142.29,-142.291 v 0 c 0,-78.269 64.03,-142.309 142.29,-142.309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path470",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5027.94,1753.04 h 219.91 c 78.02,0 141.85,63.83 141.85,141.84 v 557.74 c 0,78 -63.83,141.84 -141.85,141.84 h -219.91 c -78.02,0 -141.85,-63.84 -141.85,-141.84 v -557.74 c 0,-78.01 63.83,-141.84 141.85,-141.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path472",
    style: {
      fill: "#507087",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4420.01,2235.62 h 1462.18 c 60.94,0 110.34,49.41 110.34,110.36 v 92.36 c 0,60.94 -49.4,110.34 -110.34,110.34 H 4420.01 c -60.95,0 -110.35,-49.4 -110.35,-110.34 v -92.36 c 0,-60.95 49.4,-110.36 110.35,-110.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path474",
    style: {
      fill: "#6f8eaa",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5651.05,3347.9 h -961.11 c -36.16,0 -65.74,29.58 -65.74,65.74 v 73.91 c 0,36.15 29.58,65.74 65.74,65.74 h 961.11 c 36.16,0 65.75,-29.59 65.75,-65.74 v -73.91 c 0,-36.16 -29.59,-65.74 -65.75,-65.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path476",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5757.72,3281.46 h -734.43 c -43.68,0 -79.41,35.74 -79.41,79.42 v 176.65 c 0,43.68 35.73,79.41 79.41,79.41 h 734.43 c 89.32,0 162.39,-73.06 162.39,-162.38 v -10.71 c 0,-89.32 -73.07,-162.39 -162.39,-162.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path478",
    style: {
      fill: "#d74c6b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5885.27,3343.62 c -29.79,-37.75 -75.93,-62.16 -127.56,-62.16 h -734.42 c -37.75,0 -69.56,26.7 -77.48,62.16 h 939.46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path480",
    style: {
      fill: "#f27792",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 6094.49,2823 H 4803.24 c -128.77,0 -233.16,97.06 -233.16,216.79 v 1886.03 c 0,59.86 -52.19,108.39 -116.57,108.39 h -505.18 c -64.37,0 -116.57,-48.53 -116.57,-108.39 V 2834.31 c 0,-244.13 210.42,-442.53 471.8,-447.03 9.23,-1.12 18.61,-1.75 28.14,-1.75 h 1762.79 c 120.02,0 218.22,91.3 218.22,202.89 v 31.68 c 0,111.59 -98.2,202.9 -218.22,202.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeStock);
export default __webpack_public_path__ + "static/media/home-stock.3d970e5b0e805cdaf800626bc51e2362.svg";
export { ForwardRef as ReactComponent };